import type { i18n as I18n } from 'i18next';

// ----------------------------------------------------------------------

/**
 * Keeps `<html lang>` in step with the UI language. Screen readers pick their voice from it —
 * a wrong value reads Russian text with English pronunciation — and browsers use it for
 * hyphenation, spell-check and translation prompts.
 */
export function syncDocumentLanguage(instance: I18n) {
  const apply = (language: string) => {
    document.documentElement.lang = instance.resolvedLanguage ?? language;
  };

  instance.on('languageChanged', apply);

  const current = instance.resolvedLanguage ?? instance.language;
  if (current) apply(current);
}
